export const mobileAppRouteNames = {
  default: 'location-mobile-app',
}
